import React from 'react'
import ToDo from './pages/ToDo' 
export default function App() {
  return (
    <div className='h-screen w-screen flex justify-center items-center'>
    <ToDo />
    </div>
  )
}